
const BookIcon = () => {

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4.66667C8 3.95942 7.71905 3.28115 7.21895 2.78105C6.71886 2.28095 6.04058 2 5.33333 2H1.33333V12H6C6.53043 12 7.03914 12.2107 7.41421 12.5858C7.78929 12.9609 8 13.4696 8 14M8 4.66667V14M8 4.66667C8 3.95942 8.28095 3.28115 8.78105 2.78105C9.28115 2.28095 9.95942 2 10.6667 2H14.6667V12H10C9.46957 12 8.96086 12.2107 8.58579 12.5858C8.21071 12.9609 8 13.4696 8 14" stroke="#334155" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default BookIcon;
